// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://api.app.tapgo.ch:8443/app/v1/',
  // baseUrl: 'http://localhost:8080/app/v1/',
  S3_URL: 'https://sos-ch-dk-2.exo.io/tap-go/',
  END_POINTS: 'https://sos-ch-dk-2.exo.io',
  STRIPE_PUBLIC_KEY:
    'pk_live_51RQS8JB6uaQXxX8B9m7gDyadvT29TZbzsdyrMsXN1VggeJuBKrht4zvq9E8WfPlgG4UhLhD6ZUons0OyaLufAgRe00jfQQ4e1h',

  //  STRIPE_PUBLIC_KEY: 'pk_test_51R68BdPwibsDZsIzNJUWMI2t8kzILlupbEaNTbhShv15jbXMu5QyeM6la60MY7snL86gy3phf5lV2tW1wEeH7cPY00RPWKFPov'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
